import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Budget } from "@/components/home/Budget";
import { Manifesto } from "@/components/home/Manifesto";
import { WhyNivaan } from "@/components/home/WhyNivaan";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Services } from "@/components/home/Services";
import { Destinations } from "@/components/home/Destinations";
import { Inspiration } from "@/components/home/Inspiration";
import { About } from "@/components/home/About";
import { Founder } from "@/components/home/Founder";
import { EnquiryForm } from "@/components/home/EnquiryForm";
import { Pricing } from "@/components/home/Pricing";
import { FinalCTA } from "@/components/home/FinalCTA";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-obsidian">
      <Navbar />
      <Hero />
      <Marquee />
      <Budget />
      <Manifesto />
      <WhyNivaan />
      <HowItWorks />
      <Services />
      <Marquee light />
      <Destinations />
      <Inspiration />
      <About />
      <Founder />
      <EnquiryForm />
      <Pricing />
      <FinalCTA />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
